import React from 'react';
import './styles.css';

export default (props) => {
  const [state, setState] = React.useState({ touched: false });

  const toggleTouched = (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...state,
      touched: !prevState.touched,
    }));
  };

  const handleMouseUp = () => {
    // Handle smooth animation when clicking without holding
    setTimeout(() => {
      setState({ ...state, touched: false });
    }, 200);
  };

  const { touched } = state;
  let { className, onClick } = props;
  const _className = touched ? 'touch touched' : 'touch';
  className = className ? _className + ' ' + className : _className;
  return (
    <button
      className={className}
      onMouseDown={toggleTouched}
      onMouseUp={handleMouseUp}
      onClick={onClick}
    >
      {props.children}
    </button>
  );
};
